import React, {useState, useEffect, useRef} from 'react'
import Header from 'components/Headers/Header';
import {
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardHeader,
    Container,
    Button,
    Row,
    Col,
    CardImg,
    Media,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    Badge
} from "reactstrap";
import Swal from 'sweetalert2'
import { connect, useDispatch, useSelector } from 'react-redux';
import { fetchTpcCourses, fetchTpcCoursesReset, deleteTpcCourse, deleteTpcCourseReset, searchTpcCourses, searchTpcCoursesReset } from 'redux/ManageTpcCourses/ManageTpcCoursesActions'
import { fetchPaymentRecord } from 'redux/Payments/PaymentsActions';
import TpcCoursesLessons from 'components/Pages/TpcCoursesLessons';
import Paginate from 'components/Pagination/TpcCoursesPagination';
import CourseItemList from 'components/Courses/CourseItemList';
import { studentsLifetimePlan as studentsLifetimePlans } from "util/DataList";
import { useHistory } from 'react-router-dom';
import { hasActiveAccess, getSpecialtyFields } from 'config/subscriptionPlans';
import { getCollectionNameForSpecialty, getStorageUrl } from 'util/specialtyCollections';
import { fetchLtpItem } from "redux/ManageLifeTimePlan/ManageLifeTimePlanActions";
const TpcCourses = (props) => {

	const activeSpecialty = useSelector(state => state.specialty.activeSpecialty);

	let studentsLifetimePlan = studentsLifetimePlans

	useEffect(() => {
		dispatch(fetchLtpItem())
	}, [])

	useEffect(() => {

		if (props.fetchLtpItem.ltpitems.length) {
			const matchedItem = props.fetchLtpItem.ltpitems.find(
			  (item) => props.userDetails.email === item.email
			);
			if (matchedItem) {
				studentsLifetimePlan.push(props.userDetails.email)
				setSubscribe("unlock")
			}
		 }

	}, [props.fetchLtpItem]);

     const addZeroes = num => num.toLocaleString("en",{minimumFractionDigits: 2})

    const [modalAddTpcCourseModal, setModalAddTpcCourseModal] = useState(false);
    const [initialCourseList, setInitialCourseList] = useState([]);
    const [tpcCoursesLists, setTpcCoursesLists] = useState([]);

    const [tpcPaymentRecord,setTpcPaymentRecord] = useState([]);

    const history = useHistory();
    
    const toggleAddTpcCourseModal = () =>{
        
        setModalAddTpcCourseModal(!modalAddTpcCourseModal);
        
    } 

    const dispatch = useDispatch()
    
    useEffect(() => {
        // Clear stale data from previous specialty before fetching new
        dispatch(fetchTpcCoursesReset());
        setInitialCourseList([]);
        setTpcCoursesLists([]);
        setStartCourseData({});
        setCourseSelected('');

        dispatch(fetchPaymentRecord({table: getCollectionNameForSpecialty('tpcCourses', activeSpecialty), user: props.userDetails.handle}))
        dispatch(fetchTpcCourses({visibility: "published" }))
        fetchSubscriptionDetails()
    }, [activeSpecialty])
    
    useEffect(() => {
        
        if(props.fetchTpcCourses.tpccourses.length){
            setInitialCourseList(props.fetchTpcCourses.tpccourses)
            // const res = props.fetchTpcCourses.tpccourses.map((obj,i) => ({
            //     ...obj,
            //     payment: checkIfPaid(obj.tpcCourseId)
               
            // }))
            // setInitialCourseList(res)
        }
        
    }, [props.fetchTpcCourses ])

    useEffect(() => {
        if(props.fetchPaymentRecord.fetchpaymentrecord.length){
            setTpcPaymentRecord(props.fetchPaymentRecord.fetchpaymentrecord[0])

            setStartCourseData({})

        }
    }, [props.fetchPaymentRecord ])

    useEffect(() => {
        if(initialCourseList){

            let collectData = []

            initialCourseList.map((obj,i) => {
                console.log(initialCourseList,"fuck")
                for (let i = 0; i < tpcPaymentRecord.length; i++) {
                    if(obj.tpcCourseId == tpcPaymentRecord[i].collectionDocId){
                        obj.payment = tpcPaymentRecord[i]
                    }

                }

                let access = "free"

                if(subscribe == "unlock"){
                    access = "pro"
                }
                if(ultimateSubscribe == "unlock"){
                    access = "ultimate"
                }

                // if(JSON.parse(obj.members).some(item => item.value == access)){
                    collectData.push(obj)
                // }

            })
           setTpcCoursesLists(collectData)


        }
    }, [tpcPaymentRecord, initialCourseList])

    useEffect(() => {
      
      
        if(courseSelected != ''){
            setStartCourseData(tpcCoursesLists.find(item => item.tpcCourseId === courseSelected))
        }
        
      
    }, [tpcCoursesLists])
    

    // const checkIfPaid = (cid) => {
    //     const result = []
    //     if(tpcPaymentRecord.length > 0){
    //         tpcPaymentRecord.map((pay,i) => (
    //             pay ?  cid == pay.collectionDocId ? result.push(pay) : "" : ""
                
    //         ))
    //     }
    //     console.log(result)
    //     return result        
    // }

    
    const [startCourseData, setStartCourseData] = useState({});
    const [courseSelected, setCourseSelected] = useState('')

    const handleCourseItemCallback =  (course) => {
        const lessonCount = typeof course.category != "undefined" ? course.category.reduce((totalPublishedLessons, category) =>
        totalPublishedLessons + (category.lessons && category.lessons.filter(lesson => lesson.visibility === "published").length),
            0
        ): 0
        
        if(lessonCount == 0){
            Swal.fire({
                title:'Sorry!',
                text:'This course currently has no lessons.',
                icon :'warning',
                timer: 3000
                
              }
            )
        }
        else{
            setStartCourseData(course)
            setCourseSelected(course.tpcCourseId);
        }
       
    };

     const handleShowCourseItem =  (e,course) => {
      
        const lessonCount = typeof course.category != "undefined" ? course.category.reduce((totalPublishedLessons, category) =>
        totalPublishedLessons + (category.lessons && category.lessons.filter(lesson => lesson.visibility === "published").length),
            0
        ): 0
        
        if(lessonCount == 0){
            Swal.fire({
                title:'Sorry!',
                text:'This course currently has no lessons.',
                icon :'warning',
                timer: 3000
                
              }
            )
        }
        else{
            setStartCourseData(course)
        }
       
    };

    const handleBackToTpcCourses = (e) => {
        e.preventDefault()
        setStartCourseData({})
        setSelectedInitialLesson(null)
    }

    const [subscribe, setSubscribe] = useState('lock');
    const [ultimateSubscribe, setUltimateSubscribe] = useState('lock');
    const fetchSubscriptionDetails = () => {
        // Modern access check — same as rest of the app (covers lifetime, UAS, trial, subscription)
        if (hasActiveAccess(props.userDetails, activeSpecialty)) {
            setSubscribe('unlock')
            const uasField = getSpecialtyFields(activeSpecialty).ultimateAdvisingStudent;
            if (props.userDetails[uasField] == true || props.userDetails[uasField] == "true") {
                setUltimateSubscribe('unlock')
            }
            return;
        }

        // Legacy: check email-based lifetime plan list
        if (studentsLifetimePlan.includes(props.userDetails.email)) {
            setSubscribe('unlock')
            return;
        }

        // Legacy: check old Stripe subscription
        if (props.fetchDetailsSubscription.fetchdetailssubscription.length) {
            const subsDetails = props.fetchDetailsSubscription.fetchdetailssubscription[0]
            if (subsDetails.status == "active" || subsDetails.status == "trialing") {
                setSubscribe('unlock')
            } else if (subsDetails.cancel_at_period_end) {
                const date = new Date();
                const secondsSinceEpoch = Math.floor(date.getTime() / 1000);
                if (secondsSinceEpoch > subsDetails.canceled_at) {
                    setSubscribe('lock')
                } else {
                    setSubscribe('unlock')
                }
            } else {
                setSubscribe('lock')
            }
        } else {
            setSubscribe('lock')
        }
    }
    useEffect(() => {

        fetchSubscriptionDetails()
    
    }, [props.fetchDetailsSubscription])


    const [searchCourse, setSearchCourse] = useState("");
    const [dropdownResults, setDropdownResults] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedInitialLesson, setSelectedInitialLesson] = useState(null);
    const [searchLoading, setSearchLoading] = useState(false);
    const searchContainerRef = useRef(null);
    const debounceTimer = useRef(null);
    const lastSearchTerm = useRef("");

    const getClientSideResults = (term) => {
        const results = [];
        for (const course of tpcCoursesLists) {
            if (!course.category) continue;
            for (const category of course.category) {
                const processLessons = (lessons, subCategory) => {
                    if (!lessons) return;
                    for (const lesson of lessons) {
                        if (lesson.visibility !== "published") continue;
                        if (results.length >= 20) return;
                        const courseMatch = course.courseTitle.toLowerCase().includes(term);
                        const lessonMatch = lesson.title.toLowerCase().includes(term);
                        if (courseMatch || lessonMatch) {
                            results.push({
                                course,
                                category,
                                subCategory: subCategory || null,
                                lesson,
                                categoryId: category.id,
                                matchedIn: courseMatch && lessonMatch ? 'both' : courseMatch ? 'course' : 'lesson'
                            });
                        }
                    }
                };
                processLessons(category.lessons, null);
                if (category.subCategories) {
                    for (const sub of category.subCategories) {
                        processLessons(sub.lessons, sub);
                    }
                }
            }
            if (results.length >= 20) break;
        }
        return results;
    };

    const searchCourses = (value) => {
        setSearchCourse(value);
        lastSearchTerm.current = value;
        setCurrentPage(1);

        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        if (!value.trim()) {
            setDropdownResults([]);
            setShowDropdown(false);
            setSearchLoading(false);
            dispatch(searchTpcCoursesReset());
            return;
        }

        const term = value.toLowerCase();
        const clientResults = getClientSideResults(term);
        setDropdownResults(clientResults);
        setShowDropdown(true);

        setSearchLoading(true);
        debounceTimer.current = setTimeout(() => {
            dispatch(searchTpcCourses({ searchTerm: value }));
        }, 500);
    };

    useEffect(() => {
        return () => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
        };
    }, []);

    useEffect(() => {
        if (props.searchTpcCourses?.searchresults?.courses && lastSearchTerm.current.trim()) {
            const term = lastSearchTerm.current.toLowerCase();
            const clientResults = getClientSideResults(term);

            const clientKeys = new Set(clientResults.map(r =>
                `${r.course.tpcCourseId}-${r.lesson.title}`
            ));

            const matchedUuids = new Set(props.searchTpcCourses.searchresults.matchedLessonUuids || []);
            const snippets = props.searchTpcCourses.searchresults.transcriptSnippets || {};

            const transcriptResults = [];
            for (const apiCourse of props.searchTpcCourses.searchresults.courses) {
                const localCourse = tpcCoursesLists.find(c => c.tpcCourseId === apiCourse.tpcCourseId);
                const courseToUse = localCourse || apiCourse;
                if (!courseToUse.category) continue;

                for (const category of courseToUse.category) {
                    const addTranscriptLessons = (lessons, subCategory) => {
                        if (!lessons) return;
                        for (const lesson of lessons) {
                            if (lesson.visibility !== "published") continue;
                            if (!lesson.uuid || !matchedUuids.has(lesson.uuid)) continue;
                            if (clientResults.length + transcriptResults.length >= 30) return;
                            const key = `${courseToUse.tpcCourseId}-${lesson.title}`;
                            if (!clientKeys.has(key)) {
                                transcriptResults.push({
                                    course: courseToUse,
                                    category,
                                    subCategory: subCategory || null,
                                    lesson,
                                    categoryId: category.id,
                                    matchedIn: 'transcript',
                                    transcriptSnippet: snippets[lesson.uuid] || null
                                });
                                clientKeys.add(key);
                            }
                        }
                    };
                    addTranscriptLessons(category.lessons, null);
                    if (category.subCategories) {
                        for (const sub of category.subCategories) {
                            addTranscriptLessons(sub.lessons, sub);
                        }
                    }
                }
            }

            setDropdownResults([...clientResults, ...transcriptResults]);
            setSearchLoading(false);
        } else {
            setSearchLoading(false);
        }
    }, [props.searchTpcCourses]);

    const highlightMatch = (text, term) => {
        if (!term.trim()) return text;
        const regex = new RegExp(`(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
        const parts = text.split(regex);
        return parts.map((part, i) =>
            regex.test(part) ? <mark key={i} className="bg-yellow px-0">{part}</mark> : part
        );
    };

    const handleDropdownSelect = (result) => {
        const course = result.course;
        const lessonCount = typeof course.category != "undefined" ? course.category.reduce((totalPublishedLessons, category) =>
            totalPublishedLessons + (category.lessons && category.lessons.filter(lesson => lesson.visibility === "published").length),
            0
        ) : 0;

        if (lessonCount == 0) {
            Swal.fire({
                title: 'Sorry!',
                text: 'This course currently has no lessons.',
                icon: 'warning',
                timer: 3000
            });
        } else {
            setSelectedInitialLesson({ lesson: result.lesson, categoryId: result.categoryId, subCategoryId: result.subCategory ? result.subCategory.id : null });
            setStartCourseData(course);
            setCourseSelected(course.tpcCourseId);
        }
        setSearchCourse("");
        setDropdownResults([]);
        setShowDropdown(false);
        dispatch(searchTpcCoursesReset());
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (searchContainerRef.current && !searchContainerRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    const [currentPage, setCurrentPage] = useState(1);
	const [coursesPerPage] = useState(6);

    const filteredCourses = searchCourse.trim()
        ? tpcCoursesLists.filter(c => {
            const term = searchCourse.toLowerCase();
            if (c.courseTitle?.toLowerCase().includes(term)) return true;
            if (c.courseDescription?.toLowerCase().includes(term)) return true;
            if (c.instructorName?.toLowerCase().includes(term)) return true;
            if (c.category) {
                for (const cat of c.category) {
                    if (cat.lessons?.some(l => l.visibility === "published" && l.title?.toLowerCase().includes(term))) return true;
                    if (cat.subCategories) {
                        for (const sub of cat.subCategories) {
                            if (sub.lessons?.some(l => l.visibility === "published" && l.title?.toLowerCase().includes(term))) return true;
                        }
                    }
                }
            }
            return false;
        })
        : tpcCoursesLists;

    const indexOfLastPost = currentPage * coursesPerPage;
	const indexOfFirstPost = indexOfLastPost - coursesPerPage;
	const currentCourses = filteredCourses.slice(indexOfFirstPost, indexOfLastPost);
    
    
	const paginate = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const previousPage = () => {
		if (currentPage !== 1) {
			setCurrentPage(currentPage - 1);
		}
	};

	const nextPage = () => {
		if (currentPage !== Math.ceil(filteredCourses.length / coursesPerPage)) {
			setCurrentPage(currentPage + 1);
		}
	};    
    
    return (
        <>
            
             <div className="header bg-gradient-info pb-5 pt-5 pt-md-8">
                <Container className="" fluid>
                    <Row>
                        <Col lg="8" md="11">
                        {Object.keys(startCourseData).length !== 0 ?<>
                            <h1 className="display-2 text-white mb-4 lh-100 font-weight-bolder">{startCourseData.courseTitle}</h1>
                            
                            <Button className="shadow" color="default" onClick={(e) => handleBackToTpcCourses(e)}><i className="fas fa-arrow-left"></i>&nbsp;&nbsp;Back to Video Courses</Button>
                            </>
                         : <h1 className="display-2 text-white mb-4 lh-100 font-weight-bolder">Video Courses</h1> }
                        </Col>
                    </Row>
                </Container>
            </div>
            {Object.keys(startCourseData).length === 0? <>
            
            
            
           
            <Container className="mt--3" fluid>
                <Row >
                    <Col lg="8">
                        <div ref={searchContainerRef} style={{ position: 'relative' }}>
                            <FormGroup>
                                <InputGroup className="mb-4 input-group-lg shadow">
                                    <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="fas fa-search" />
                                    </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        placeholder="Search courses and lessons.."
                                        type="text"
                                        className='pl-3'
                                        value={searchCourse}
                                        onFocus={() => { if (searchCourse.trim()) setShowDropdown(true); }}
                                        onChange={(e) => searchCourses(e.target.value)}
                                    />
                                    {searchCourse && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => { setSearchCourse(""); setDropdownResults([]); setShowDropdown(false); dispatch(searchTpcCoursesReset()); }}
                                            >
                                                <i className="fas fa-times" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}
                                </InputGroup>
                            </FormGroup>
                            {showDropdown && (
                                <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    zIndex: 1050,
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    backgroundColor: '#fff',
                                    borderRadius: '0.375rem',
                                    boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.15)',
                                    marginTop: '-1rem'
                                }}>
                                    {dropdownResults.length > 0 ? dropdownResults.map((result, i) => (
                                        <div
                                            key={i}
                                            onClick={() => handleDropdownSelect(result)}
                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f6f9fc'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
                                            style={{
                                                padding: '10px 15px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #e9ecef',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <i className="fas fa-play-circle text-default mr-3" style={{ fontSize: '1.1rem', flexShrink: 0 }}></i>
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <small className="text-muted">{highlightMatch(result.course.courseTitle, searchCourse)}</small>
                                                <div className="font-weight-bold text-darker">{highlightMatch(result.lesson.title, searchCourse)}</div>
                                                {result.matchedIn === 'transcript' && result.transcriptSnippet && (
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem', lineHeight: '1.3', marginTop: '2px' }}>
                                                        <i className="fas fa-file-alt mr-1"></i>
                                                        {highlightMatch(result.transcriptSnippet, searchCourse)}
                                                    </small>
                                                )}
                                            </div>
                                            {result.matchedIn === 'transcript' && (
                                                <Badge color="info" pill className="ml-2" style={{ fontSize: '0.65rem', flexShrink: 0 }}>transcript</Badge>
                                            )}
                                        </div>
                                    )) : (
                                        <div style={{ padding: '15px', textAlign: 'center', color: '#8898aa' }}>
                                            {searchLoading ? 'Searching transcripts...' : 'No matching courses or lessons found.'}
                                        </div>
                                    )}
                                    {searchLoading && dropdownResults.length > 0 && (
                                        <div style={{ padding: '8px 15px', textAlign: 'center', color: '#8898aa', borderTop: '1px solid #e9ecef' }}>
                                            <i className="fas fa-spinner fa-spin mr-2"></i>
                                            <small>Searching transcripts...</small>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </Col>

                </Row>

                <Row>
                    <Col lg="12" md="12" className='mt-3'>
                    {
                        !filteredCourses.length ?
                            <Card className='shadow'>
                                <CardBody className='text-center'>
                                    <h2 className='mb-0'>{searchCourse.trim() ? 'No matching courses found.' : 'No courses listed.'}</h2>
                                </CardBody>
                            </Card>
                            :
                            <Row>
                                {
                                    currentCourses.map((c, i) => {
                                        return <CourseItemList key={c.tpcCourseId} item={c} courseCallback={handleCourseItemCallback} />
                                    })
                                }
                                <Col xl="12" lg="12">
                                {
                                    filteredCourses.length > coursesPerPage ?
                                    <div className="d-flex justify-content-center mt-3">
                                        <Paginate
                                            itemPerPage={coursesPerPage}
                                            totalItems={filteredCourses.length}
                                            currentPage={currentPage}
                                            paginate={paginate}
                                            previousPage={previousPage}
                                            nextPage={nextPage}
                                        />
                                    </div>
                                    :""
                                }
                                </Col>
                            </Row>
                    }

                    </Col> 
                    {/* <Col lg="4" md="12" className='mt-3'>
                        <Card className="shadow-lg align-center bg-white rounded mb-5">
                            <CardHeader>
                                <CardTitle className=" font-weight-bold">My Purchases </CardTitle>
                                <CardSubtitle className="">({ tpcPaymentRecord.length }) Items</CardSubtitle>
                            </CardHeader>
                            <CardBody>
                                {
                                    tpcPaymentRecord.length ? 
                                        tpcPaymentRecord.map((p,i) => {
                                            return( 
                                                <Card  role="button" className="m-2 shadow-lg bg-white rounded"  onClick={e => handleShowCourseItem(e, p.documentItem)}>
                                                    <div class="media">
                                                        <img 
                                                        style={{ width: '110px', height: '90px' }}
                                                        src={ p.documentItem.courseThumbnail != "" 
                                                        ?  getStorageUrl('img-tpc-courses', p.documentItem.courseThumbnail, activeSpecialty)
                                                        : require("assets/img/brand/no-image.jpg")} className="mr-3" alt="..." 
                                                        />
                                                        <div className="media-body p-2">
                                                            <h5 className="m-1 ">{p.documentItem.courseTitle}</h5>
                                                            <Badge color="success" className="mr-2" pill >Purchased</Badge>
                                                            <Badge color="info" className="mr-2 text-dark" pill >${ addZeroes(Number(p.documentItem.coursePrice))}</Badge>
                                                        </div>
                                                    </div>
                                                </Card>
                                            )
                                        
                                        })
                                    : "No purchased yet."
                                }
                                
                            </CardBody>
                        </Card>
                    </Col> */}
                   
                </Row>
                
            </Container>
            </>
            : <Container className="mt-4" fluid><TpcCoursesLessons courseData={startCourseData} initialLesson={selectedInitialLesson}></TpcCoursesLessons></Container>}
            
        
        </>
    )
}

const mapStateToProps = state  => {
    return {
        userDetails : state.loginAuth.userDetails,
        fetchTpcCourses : state.fetchTpcCourses,
        createTpcCourse : state.createTpcCourse,
        updateTpcCourse : state.updateTpcCourse,
        deleteTpcCourse : state.deleteTpcCourse,
        fetchDetailsSubscription : state.fetchDetailsSubscription,
        fetchPaymentRecord: state.fetchPaymentRecord,
        adminUser : state.adminUser,
        fetchLtpItem : state.fetchLtpItem,
        searchTpcCourses : state.searchTpcCourses
    }

}

export default connect(mapStateToProps)(TpcCourses)
